import { LookupListModel } from '../../../lookup/lookup-list';
import { ElasticsearchFieldModel } from '../../../elasticsearch/elasticsearch-field';
import { ElasticsearchFilterModel, ElasticsearchFilterOperator } from '../../../elasticsearch/elasticsearch-filter';
import lookupFilterParser from '../../../osd/filters/parsers/lookup-filter-parser';
import { BaseAlertFilterParser } from './base';
/**
 * Elastic to ElasticsearchFilterModel 'LOOKUP' filter parser
 */
export class AlertFilterLookupFilterParser extends BaseAlertFilterParser {
    constructor() {
        super(lookupFilterParser);
    }
    getFilter(elasticFilter, negate) {
        const metadata = this.getMetadata(elasticFilter, negate);
        if (!metadata)
            return null;
        const filter = new ElasticsearchFilterModel();
        const lookupTable = new LookupListModel();
        lookupTable.id = metadata.id;
        lookupTable.name = metadata.name;
        filter.type = ElasticsearchFilterOperator.Lookup;
        filter.value = lookupTable;
        filter.negate = metadata.negate;
        filter.field = new ElasticsearchFieldModel();
        filter.field.name = metadata.key ?? '';
        return filter;
    }
    getElasticFilter(filter) {
        if (filter.type !== ElasticsearchFilterOperator.Lookup)
            return null;
        return {
            [this.baseFilterParser.elasticKey]: {
                id: filter.value.id,
                name: filter.value.name,
                field: filter.field?.name,
            },
        };
    }
}
//# sourceMappingURL=lookup.js.map